<div class="animated fadeIn">

  <tabset>

    <!-- ===== TAB LEAGUES ===== -->
    <tab heading="Leagues" (selectTab)="onSelectLeaguesTab()">
      <div class="card mt-3">
        <div class="card-header">
          <i class="fa fa-trophy"></i> Leagues
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAddLeague()">
              <i class="fa fa-plus"></i> Add League
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Tier</th>
                <th>Previous Tier</th>
                <th>Next Tier</th>
                <th>Free Credits Bonus</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (leaguesIsLoading) {
                <tr>
                  <td colspan="7" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else if (leagues.length === 0) {
                <tr>
                  <td colspan="7" class="text-center text-muted">No leagues found.</td>
                </tr>
              } @else {
                @for (league of leagues; track league.leagueId) {
                  <tr>
                    <td>{{ league.leagueId }}</td>
                    <td>{{ league.name }}</td>
                    <td>{{ league.tier }}</td>
                    <td>{{ getLeagueTierById(league.leaguePreviousId) }}</td>
                    <td>{{ getLeagueTierById(league.leagueNextId) }}</td>
                    <td>{{ league.freeCreditsBonus }}</td>
                    <td>
                      <button class="btn btn-sm btn-info me-1" type="button" (click)="onClickLeagueRewards(league)" tooltip="Rewards" placement="top"><i class="fa fa-gift"></i></button>
                      <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEditLeague(league)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeleteLeague(league)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </tab>

    <!-- ===== TAB DIVISIONS ===== -->
    <tab heading="Divisions" (selectTab)="onSelectDivisionsTab()">
      <!-- Filters -->
      <div class="card mt-3">
        <div class="card-header" (click)="divisionsIsFilterOpen = !divisionsIsFilterOpen" style="cursor:pointer">
          <i class="fa fa-filter"></i> Filtres
          <div class="pull-right">
            @if (divisionsIsFilterOpen) {
              <i class="fa fa-chevron-down"></i>
            } @else {
              <i class="fa fa-chevron-left"></i>
            }
          </div>
        </div>
        <div class="card-body" [collapse]="!divisionsIsFilterOpen">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label>League</label>
                <select class="form-control" [(ngModel)]="divisionsFilters.league_id">
                  <option [ngValue]="null">— All —</option>
                  @for (league of leagues; track league.leagueId) {
                    <option [ngValue]="league.leagueId">{{ league.name }} (Tier {{ league.tier }})</option>
                  }
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>End Date (min)</label>
                <input class="form-control" type="date" [(ngModel)]="divisionsEndDateMinFilter">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>End Date (max)</label>
                <input class="form-control" type="date" [(ngModel)]="divisionsEndDateMaxFilter">
              </div>
            </div>
          </div>
          <div class="filters-buttons">
            <button [disabled]="divisionsIsLoading" class="btn btn-sm btn-primary" (click)="onClickDivisionsFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button [disabled]="divisionsIsLoading" class="btn btn-sm btn-danger" (click)="onClickDivisionsResetFilters()"><i class="fa fa-ban"></i> Reset</button>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card mt-3">
        <div class="card-header">
          <i class="fa fa-list"></i> Divisions
        </div>
        <div class="card-body">
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Division ID</th>
                <th>Tier</th>
                <th>End Date</th>
                <th>Users</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (divisionsIsLoading) {
                <tr>
                  <td colspan="7" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else if (divisions.length === 0) {
                <tr>
                  <td colspan="7" class="text-center text-muted">No divisions found.</td>
                </tr>
              } @else {
                @for (division of divisions; track division.divisionId; let i = $index) {
                  <tr>
                    <td>{{ (divisionsPageNumber - 1) * divisionsResultsPerPage + i + 1 }}</td>
                    <td>{{ division.divisionId }}</td>
                    <td>{{ division.leagueTier }}</td>
                    <td>{{ dateService.getDateFromatted(division.endDateTimestamp) }}</td>
                    <td>{{ division.usersCount }}</td>
                    <td>
                      @if (isDivisionInProgress(division.endDateTimestamp)) {
                        <span class="badge bg-success">In Progress</span>
                      } @else {
                        <span class="badge bg-secondary">Past</span>
                      }
                    </td>
                    <td>
                      <button class="btn btn-sm btn-info" type="button" (click)="onClickDivisionUsers(division)" tooltip="Users" placement="top"><i class="fa fa-users"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (divisionsPageNumber - 1) * divisionsResultsPerPage + 1 }} to {{ (divisionsPageNumber - 1) * divisionsResultsPerPage + divisions.length }} of {{ divisionsTotalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="divisionsPageNumber <= 1">
                <button class="page-link" (click)="onDivisionsPaginationPrevious()" [disabled]="divisionsPageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(divisionsPageNumber, divisionsTotalPages); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === divisionsPageNumber">
                    <button class="page-link" (click)="divisionsGoToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="divisionsPageNumber >= divisionsTotalPages">
                <button class="page-link" (click)="onDivisionsPaginationNext()" [disabled]="divisionsPageNumber >= divisionsTotalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </tab>

    <!-- ===== TAB CONFIGURATIONS ===== -->
    <tab heading="Configurations">
      <app-configurations-block [configurations]="leagueConfigurations" [collapsible]="false" />
    </tab>

  </tabset>
</div>

<app-league-add-modal #leagueAddModal></app-league-add-modal>
<app-league-edit-modal #leagueEditModal></app-league-edit-modal>
<app-league-rewards-modal #leagueRewardsModal></app-league-rewards-modal>
<app-league-division-users-modal #leagueDivisionUsersModal></app-league-division-users-modal>
